// PKCE (RFC 7636) for a sign-in that returns through a custom URL scheme. Any
// app on the computer can claim the scheme, so a code read from it is useless
// without the verifier, which never leaves this process until the token request.

const base64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...Array.from(bytes)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

const randomToken = () => base64Url(crypto.getRandomValues(new Uint8Array(32)));

export async function pkceChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64Url(new Uint8Array(digest));
}

export async function createPkce() {
  const verifier = randomToken();
  return { verifier, challenge: await pkceChallenge(verifier), state: randomToken() };
}
